/**
 * В зависимости от скролла прячем или показываем хедер
 * или делаем его компактным
 */

import { throttle } from './Util.js';


class FixedHeader {
    constructor() {
        this.prevScroll = 0;
        this.$arrow = $('.js-header-arrow');
        this.$link = $('.js-header-back-link');
        this.$inner = $('.js-header-inner');

        this.toggleVisible();
        this.resizeArrow();
        this.bindEvents();
    }



    bindEvents() {
        // App.W.one('scroll', () => {
            App.W.on('scroll', throttle(this.toggleVisible.bind(this), 20));
        // });

        App.W.on('resized', this.resizeArrow.bind(this));
    }



    /**
     * При скролле вниз прячем хедер,
     * при скроле вверх — показываем
     */
    toggleVisible() {


        const scrollTop = App.W.scrollTop();

        if (this.prevScroll > scrollTop || scrollTop < 1) {
            App.H.removeClass('_header-hidden');
        } else {
            App.H.addClass('_header-hidden').removeClass('_search-open');
        }

        this.prevScroll = scrollTop;

        this.toggleCompact(scrollTop);
    }



    /**
     * Если это не самый верх страницы,
     * хедер имеет компактный вид
     */
    toggleCompact(scrollTop) {
        if (scrollTop > 0) {
            App.H.addClass('_header-compact');
        } else {
            App.H.removeClass('_header-compact');
        }
    }



    /**
     * Считаем длину стрелки в хедере (свойство left)
     * в зависимости от длины ссылки, на которую
     * она должна указывать
     */
    resizeArrow() {
        if (!this.$link.length) { return; }
        if (App.H.is('.page-expertise-inner')) { return; }

        const margin = App.H.width() > 767 ? 30 : 12;

        /**
         * Начиная с вертикального планшета взаимное расположение
         * блоков меняется, поэтому считаем по-разному
         */
        if (App.H.width() > 999) {
            const x1 = this.$link.offset().left + this.$link.width();
            const x2 = this.$inner.offset().left;

            this.$arrow.css({
                left: `-${x2 - x1 - margin}px`
            });
        } else {
            const x3 = this.$link.width();

            this.$arrow.css({
                left: `${x3 + margin}px`
            });
        }
    }
}

new FixedHeader();



// WEBPACK FOOTER //
// ./_src/js/modules/FixedHeader.js